<template>
  <div class="my-4">
    
    <div
      class="Polaris-Banner Polaris-Banner--statusInfo Polaris-Banner--hasDismiss Polaris-Banner--withinPage"
      tabindex="0"
      role="status"
      aria-live="polite"
      v-if="banner.desktopMessage && !sendMessagesUsingDesktopApp"
    >
      <div class="Polaris-Banner__Dismiss">
        <button
          class="Polaris-Button Polaris-Button--plain Polaris-Button--iconOnly"
          aria-label="Dismiss notification"
          type="button"
          @click="closeBanner('desktopMessage')"
        >
          <span class="Polaris-Button__Content">
            <span class="Polaris-Button__Icon">
              <span class="Polaris-Icon">
                <span class="Polaris-Text--root Polaris-Text--visuallyHidden">
                </span>
                <svg
                  viewBox="0 0 20 20"
                  class="Polaris-Icon__Svg"
                  focusable="false"
                  aria-hidden="true"
                >
                  <path
                    d="M6.707 5.293a1 1 0 0 0-1.414 1.414l3.293 3.293-3.293 3.293a1 1 0 1 0 1.414 1.414l3.293-3.293 3.293 3.293a1 1 0 0 0 1.414-1.414l-3.293-3.293 3.293-3.293a1 1 0 0 0-1.414-1.414l-3.293 3.293-3.293-3.293Z"
                  ></path>
                </svg>
              </span>
            </span>
          </span>
        </button>
      </div>
      <div
        class="Polaris-Box"
        style="--pc-box-padding-inline-end-xs:var(--p-space-4)"
      >
        <span
          class="Polaris-Icon Polaris-Icon--colorHighlight Polaris-Icon--applyColor"
        >
          <span class="Polaris-Text--root Polaris-Text--visuallyHidden"> </span>
          <svg
            viewBox="0 0 20 20"
            class="Polaris-Icon__Svg"
            focusable="false"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M10 20c5.514 0 10-4.486 10-10s-4.486-10-10-10-10 4.486-10 10 4.486 10 10 10zm1-6a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0v4zm-1-9a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
            ></path>
          </svg>
        </span>
      </div>
      <div class="Polaris-Banner__ContentWrapper">
        <div
          class="Polaris-Box"
          style="--pc-box-padding-block-end-xs:var(--p-space-05);--pc-box-padding-block-start-xs:var(--p-space-05)"
        >
          <p>
            Did you know you can send manual messages using Whatsapp Desktop?
            <button
              type="button"
              class="Polaris-Link Polaris-Link--monochrome"
              @click="gotoPreferences"
            >
              Update preferences
            </button>
          </p>
        </div>
      </div>
    </div>
    <!-- <div
      v-if="banner.invalidError"
      class="Polaris-Banner Polaris-Banner--hasDismiss Polaris-Banner--withinPage"
      tabindex="0"
      role="status"
      aria-live="polite"
    >
      <div class="Polaris-Banner__Dismiss">
        <button
          class="Polaris-Button Polaris-Button--plain Polaris-Button--iconOnly"
          aria-label="Dismiss notification"
          type="button"
          @click="closeBanner('invalidError')"
        >
          <span class="Polaris-Button__Content">
            <span class="Polaris-Button__Icon">
              <span class="Polaris-Icon">
                <span
                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                >
                </span>
                <svg
                  viewBox="0 0 20 20"
                  class="Polaris-Icon__Svg"
                  focusable="false"
                  aria-hidden="true"
                >
                  <path
                    d="M6.707 5.293a1 1 0 0 0-1.414 1.414l3.293 3.293-3.293 3.293a1 1 0 1 0 1.414 1.414l3.293-3.293 3.293 3.293a1 1 0 0 0 1.414-1.414l-3.293-3.293 3.293-3.293a1 1 0 0 0-1.414-1.414l-3.293 3.293-3.293-3.293Z"
                  ></path>
                </svg>
              </span>
            </span>
          </span>
        </button>
      </div>
      <div
        class="Polaris-Box"
        style="--pc-box-padding-inline-end-xs:var(--p-space-4)"
      >
        <span
          class="Polaris-Icon Polaris-Icon--colorBase Polaris-Icon--applyColor"
        >
          <span
            class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
          >
          </span>
          <svg
            viewBox="0 0 20 20"
            class="Polaris-Icon__Svg"
            focusable="false"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M10 20c5.514 0 10-4.486 10-10s-4.486-10-10-10-10 4.486-10 10 4.486 10 10 10zm1-6a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0v4zm-1-9a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
            ></path>
          </svg>
        </span>
      </div>
      <div class="Polaris-Banner__ContentWrapper">
        <div
          class="Polaris-Box"
          style="--pc-box-padding-block-end-xs:var(--p-space-05);--pc-box-padding-block-start-xs:var(--p-space-05)"
        >
          <p>
            Are you are getting "Phone number shared via url is invalid" while
            you try to send?
            <button
              type="button"
              class="Polaris-Link Polaris-Link--monochrome"
              @click="gotoManualMessageError"
            >
              View Solution
            </button>
          </p>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShopifyWebview: false,
      banner: {
        showNavChange: true,
        desktopMessage: true,
        invalidError: true
      }
    };
  },
  computed: {
    sendMessagesUsingDesktopApp() {
      const store = this.$store.getters.getStore;
      return store.sendMessagesUsingDesktopApp;
    }
  },
  created() {
    const bannerKeys = Object.keys(this.banner);
    for (const key of bannerKeys) {
      try {
        const bannerItem = localStorage.getItem(key);
        if (bannerItem) {
          this.banner[key] = false;
        }
      } catch (error) {
        console.log("error in setting banner");
      }
    }
  },
  methods: {
    contact() {
      $crisp.push(["do", "chat:open"]); // eslint-disable-line
      // eslint-disable-next-line
      $crisp.push([
        "set",
        "message:text",
        [`Hi, am getting the phone number shared via URL is an invalid error. `]
      ]);
    },
    closeBanner(key) {
      this.banner[key] = false;
      localStorage.setItem(key, true);
    },
    gotoManualMessageError() {
      this.$router.push({ name: "ManualMessageError" });
    },
    gotoPreferences() {
      this.$router.push({ name: "Preference" });
    }
  }
};
</script>

<style lang="scss" scoped></style>
